// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"99":"1292dbb9","238":"ae26b933","260":"606caf37","532":"0087ed2e","563":"6a553528","882":"6a553528"}[chunkId] + ".css";
};